import React, { Component } from "react";
import {
    Paper,
    Grid,
    List,
    ListItem,
    ListItemText,
    Typography,
    ListItemAvatar,
    Avatar,
    Button,
} from "@material-ui/core";
import styled from "styled-components";
import { Row, Col, Modal, ModalBody, ModalFooter } from "reactstrap";
import { StyledContent, StyledHeader } from "../../../../styles";
import { connect } from "react-redux";
import icons from "./imgs";
import { getReportTitles, getActivities, deleteActivity } from "./actions";
import { hot } from "react-hot-loader";
import icons2 from "./icons.json";
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';

// const styles = () => ({
//     addUserModel: {
//         width: "60%",
//     },
//     list: {
//         width: "100%",
//         marginTop: 15,
//         marginBottom: 1,
//         borderRadius: 5,
//         backgroundColor: "#3f51b5",
//     },
//     listItem: {
//         width: "auto",
//         backgroundColor: "white",
//         marginLeft: 10,
//         marginRight: 10,
//         borderRadius: 5,
//         marginBottom: 1,
//         marginTop: 1,
//         padding: 0,
//     },
//     table: {
//         minWidth: 500,
//     },
//     tableWrapper: {
//         overflowX: "auto",
//     },
//     form: {
//         position: "relative",
//         width: "90%",
//     },
//     MessageList: {
//         width: "100%",
//         backgroundColor: "#dddddd",
//     },
//     MessageItem: {
//         width: "auto",
//         margin: 12,
//         backgroundColor: "#fff",
//         borderRadius: 6,
//     },
// });
const ModalRow = styled(Row)`
    margin-bottom: 10px;
`;
class ActivityLogWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            limit: 50,
            deleteActivityModal: false,
            key: "",
        };
        props.getReportTitles();
        props.getActivities(50);
    }
    
    getContent(item) {
        console.log(item.subject_child,"item")
        switch (item.subject_child) {
            case "vehicle": {
                return `${item.user_name} has ${item.operation}d a vehicle with reg: ${item.subject_name}`;
            }
            case "jobpack": {
                return `${item.user_name} has ${item.operation}d a jobpack named: ${item.subject_name}`;
            }
            case "toolbox": {
                return `${item.user_name} has ${item.operation}d a toolbox talk named: ${item.subject_name}`;
            }
            case "equipment": {
                return `${item.user_name} has ${item.operation}d a piece of equipment named: ${item.subject_name}`;
            }
            case "report": {
                return `${item.user_name} has ${item.operation}d a ${
                    this.props.reportTitles
                        ? this.props.reportTitles[item.subject_name]
                        : item.subject_name
                }  `;

            }
            case "reports": {
                return `${item.user_name} presented a Toolbox Talk`;
            }
            default: {
                return "Unknown Activity";
            }
        }
    }
    render() {
        const { sm, md, lg, activities } = this.props;
        const { limit } = this.state;
        return (
            <Grid item sm={sm} md={md} lg={lg}>
                <Paper
                    style={{
                        borderRadius: 0,
                        position: "relative",
                        overflow: "hidden",
                        height: "450px",
                    }}
                >
                    <Typography variant="h6" style={{ padding: 24 }}>
                        Recent Activities
                    </Typography>
                    <List
                        style={{
                            overflowY: "scroll",
                            height: "380px",
                            width: "100%",
                            backgroundColor: "#dddddd",
                        }}
                    >
                        {activities &&
                            this.props.reportTitles &&
                            activities.map((e) => {
                                let icon_path = '';
                                if(e.subject_child === 'report'  && icons2[e.subject_name]){
                                    icon_path = icons2[e.subject_name].selected;
                                }else{
                                    icon_path = icons2['jobpack_icon_empty'].selected;
                                }
                                return (
                                    
                                    <ListItem
                                        alignItems="flex-start"
                                        style={{
                                            width: "auto",
                                            margin: 12,
                                            backgroundColor: "#fff",
                                            borderRadius: 6,
                                        }}
                                    >
                                    
                                    <>

                                        { e.subject_child === 'report' ?
                                        <ListItemAvatar>
                                            <div class="container" style={{position:"relative",textAlign:"center",color:"white"}}>
                                            <Avatar
                                                variant={"rounded"}
                                                src={icon_path}
                                                style={{
                                                    height: "50px",
                                                    width: "50px",
                                                }}
                                                alt="na"
                                            />
                                            <div class="top-right" style={{ position:"absolute",top:"-8px",right:"6px"}}>
                                                {e.operation === "create" ? <AddCircleOutlineRoundedIcon style={{color:"#00ff00",backgroundColor:"#B0B0B0",borderRadius:"20px"}} /> : <></> }
                                                {e.operation === "edit" ? <EditRoundedIcon style={{color:"blue",backgroundColor:"#B0B0B0",borderRadius:"20px"}} /> : <></> }
                                                {e.operation === "delete" ? <HighlightOffRoundedIcon style={{color:"red",backgroundColor:"#B0B0B0",borderRadius:"20px"}}/> : <></> }
                                               
                                            </div>
                                            </div>
                                        </ListItemAvatar>
                                     : <>
                                     {icons[e.subject_child] && (
                                        <ListItemAvatar>
                                            <div class="container" style={{position:"relative",textAlign:"center",color:"white"}}>
                                            <Avatar
                                                variant={"rounded"}
                                                src={
                                                    icons[e.subject_child][
                                                        e.operation
                                                    ]
                                                }
                                                style={{
                                                    height: "50px",
                                                    width: "50px",
                                                }}
                                                alt="na"
                                            />
                                            </div>
                                        </ListItemAvatar>
                                    )}</> }

                                    <ListItemText
                                        primary={this.getContent(e)}
                                        secondary={e.timestamp}
                                    />
                                    {/* <IconButton
                                        style={{
                                            color: "red",
                                            paddingBottom: "10px",
                                            float: "right",
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                deleteActivityModal: true,
                                                key: e.key,
                                            });
                                        }}
                                    >
                                        <DeleteIcon />
                                    </IconButton> */}
                                    </>
                                    
                                    </ListItem>

                                );
                            })}
                        {limit > 50 ? 
                        <ListItem
                            button
                            onClick={() => {
                                this.props.getActivities(limit + 50);
                                this.setState({
                                    limit: limit + 50,
                                });
                            }}
                            style={{
                                width: "auto",
                                margin: 12,
                                backgroundColor: "#fff",
                                borderRadius: 6,
                            }}
                            alignItems="flex-start"
                        >
                            <ListItemText primary={"See More ..."} />
                        </ListItem> : '' }
                        
                    </List>
                    {/* ----------------------------------------Delete Activity Modal ----------------------- */}
                    <div>
                        <Modal isOpen={this.state.deleteActivityModal}>
                            <StyledHeader>
                                <Typography variant="h5">
                                    Remove Activity from ActivityLog
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <p>
                                                <b>
                                                    Are you sure you want to
                                                    delete this Activity from
                                                    ActivityLog?
                                                </b>
                                            </p>
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                deleteActivityModal: false,
                                                key: "",
                                            });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            backgroundColor: "red",
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            this.props.deleteActivity(
                                                this.state.key
                                            );
                                            this.setState({
                                                deleteActivityModal: false,
                                                key: "",
                                            });
                                            this.props.getActivities(50);
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                </Paper>
            </Grid>
        );
    }
}

export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const {
                selectRegisteredUsers,
                selectActivities,
                getReportTitles,
            } = selectors;

            return {
                users: selectRegisteredUsers(store),
                activities: selectActivities(store),
                reportTitles: getReportTitles(store),
            };
        },
        { getReportTitles, getActivities, deleteActivity }
    )(ActivityLogWidget)
);
